import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestAssignDeliveryCompany } from "./assignDeliveryCompany.request";
import { AssignDeliveryCompanyResponse } from "./assignDeliveryCompany.types";

const useAssignDeliveryCompany = (
  options?: MutationOptions<
    AssignDeliveryCompanyResponse,
    ApiServiceError<ApiError>
  >
) => {
  return useMutation({
    mutationFn: requestAssignDeliveryCompany,
    ...options
  });
};

export default useAssignDeliveryCompany;
